import React from "react";

interface ISixshopProIconProps {
  width?: number;
  height?: number;
}

const SixshopProIcon: React.FC<ISixshopProIconProps> = ({
  width = 377,
  height = 79,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 377 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M80.7771 37.0689C80.7771 35.2302 82.5164 34.2768 84.657 34.2768C87.1322 34.2768 89.0053 35.5707 90.0087 37.7499L97.3672 33.6639C94.7583 28.9649 90.0756 26.4451 84.657 26.4451C77.7667 26.4451 71.9468 30.3269 71.9468 37.2732C71.9468 49.259 89.2059 46.535 89.2059 51.5064C89.2059 53.4813 87.3329 54.4347 84.5901 54.4347C81.2453 54.4347 78.9709 52.8003 78.0343 50.0082L70.542 54.2985C72.9502 59.5423 77.9005 62.4026 84.5901 62.4026C91.748 62.4026 98.0362 58.8613 98.0362 51.5064C98.0362 38.9758 80.7771 42.1084 80.7771 37.0689Z"
        fill="#222222"
      />
      <path
        d="M107.867 23.3125C110.811 23.3125 113.219 20.8608 113.219 17.9325C113.219 15.0041 110.811 12.4844 107.867 12.4844C104.991 12.4844 102.582 15.0041 102.582 17.9325C102.582 20.8608 104.991 23.3125 107.867 23.3125ZM103.586 61.4492H112.215V27.3985H103.586V61.4492Z"
        fill="#222222"
      />
      <path
        d="M150.953 61.4492L138.711 44.0152L150.418 27.3985H140.517L133.761 37.0008L127.004 27.3985H117.037L128.743 44.0833L116.502 61.4492H126.469L133.761 51.0978L140.985 61.4492H150.953Z"
        fill="#222222"
      />
      <path
        d="M161.13 37.0689C161.13 35.2302 162.87 34.2768 165.01 34.2768C167.486 34.2768 169.359 35.5707 170.362 37.7499L177.721 33.6639C175.112 28.9649 170.429 26.4451 165.01 26.4451C158.12 26.4451 152.3 30.3269 152.3 37.2732C152.3 49.259 169.559 46.535 169.559 51.5064C169.559 53.4813 167.686 54.4347 164.944 54.4347C161.599 54.4347 159.324 52.8003 158.388 50.0082L150.895 54.2985C153.304 59.5423 158.254 62.4026 164.944 62.4026C172.101 62.4026 178.39 58.8613 178.39 51.5064C178.39 38.9758 161.13 42.1084 161.13 37.0689Z"
        fill="#222222"
      />
      <path
        d="M202.863 26.4451C198.381 26.4451 194.902 28.1477 192.896 31.2122V13.7783H184.266V61.4492H192.896V43.0618C192.896 37.137 196.04 34.6173 200.254 34.6173C204.134 34.6173 206.877 37.0008 206.877 41.6317V61.4492H215.506V40.5421C215.506 31.4846 209.954 26.4451 202.863 26.4451Z"
        fill="#222222"
      />
      <path
        d="M237.458 62.4026C247.292 62.4026 255.186 54.5709 255.186 44.4239C255.186 34.2768 247.292 26.4451 237.458 26.4451C227.624 26.4451 219.798 34.2768 219.798 44.4239C219.798 54.5709 227.624 62.4026 237.458 62.4026ZM237.458 53.8218C232.374 53.8218 228.427 49.94 228.427 44.4239C228.427 38.9076 232.374 35.0259 237.458 35.0259C242.609 35.0259 246.556 38.9076 246.556 44.4239C246.556 49.94 242.609 53.8218 237.458 53.8218Z"
        fill="#222222"
      />
      <path
        d="M279.385 26.4451C274.502 26.4451 270.956 28.2839 268.548 31.4165V27.3985H259.918V75.0694H268.548V57.4312C270.956 60.5638 274.502 62.4026 279.385 62.4026C288.349 62.4026 295.708 54.5709 295.708 44.4239C295.708 34.2768 288.349 26.4451 279.385 26.4451ZM277.78 54.0261C272.495 54.0261 268.548 50.1444 268.548 44.4239C268.548 38.7033 272.495 34.8216 277.78 34.8216C283.131 34.8216 287.078 38.7033 287.078 44.4239C287.078 50.1444 283.131 54.0261 277.78 54.0261Z"
        fill="#222222"
      />
      <path
        d="M31.3842 22.265V10.5303H7.88867V22.265V45.7344C7.88867 32.7732 18.4087 22.265 31.3842 22.265Z"
        fill="#B3AEF1"
      />
      <path
        d="M31.3842 22.2656V45.7352H7.88867C7.88867 58.6965 18.4087 69.2049 31.3842 69.2049C44.3598 69.2049 54.8798 58.6965 54.8798 45.7352C54.8798 32.774 44.3598 22.2656 31.3842 22.2656Z"
        fill="#A099EE"
      />
      <path
        d="M31.3842 22.2656C18.4087 22.2656 7.88867 32.774 7.88867 45.7352H31.3842V22.2656Z"
        fill="#4037A3"
      />
      <rect x="308" y="22" width="69" height="40.8553" rx="8" fill="#5E51F0" />
      <path
        d="M358.946 48.7866C354.142 48.7866 350.285 45.0279 350.285 40.1579C350.285 35.288 354.142 31.5293 358.946 31.5293C363.751 31.5293 367.608 35.288 367.608 40.1579C367.608 45.0279 363.751 48.7866 358.946 48.7866ZM358.946 44.0147C361.071 44.0147 362.705 42.4785 362.705 40.1579C362.705 37.8373 361.071 36.3012 358.946 36.3012C356.822 36.3012 355.188 37.8373 355.188 40.1579C355.188 42.4785 356.822 44.0147 358.946 44.0147Z"
        fill="white"
      />
      <path
        d="M344.388 34.8949C345.042 32.7051 347.232 31.6592 349.291 31.6592V37.2155C347.264 36.8887 344.388 37.7058 344.388 40.9415V48.3281H339.485V31.986H344.388V34.8949Z"
        fill="white"
      />
      <path
        d="M328.894 31.5293C333.175 31.5293 336.705 35.288 336.705 40.1579C336.705 45.0279 333.175 48.7866 328.894 48.7866C326.704 48.7866 325.102 48.0348 324.024 46.7928V54.8658H319.121V31.9869H324.024V33.523C325.102 32.281 326.704 31.5293 328.894 31.5293ZM327.913 44.1454C330.168 44.1454 331.803 42.6092 331.803 40.1579C331.803 37.7066 330.168 36.1705 327.913 36.1705C325.658 36.1705 324.024 37.7066 324.024 40.1579C324.024 42.6092 325.658 44.1454 327.913 44.1454Z"
        fill="white"
      />
    </svg>
  );
};

export default SixshopProIcon;
